import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// Images
import financialPlanningImageDesktopWebp from './images/grandfather-granddaughter-mountain-biking.webp';
import financialPlanningImageMobileWebp from './images/grandfather-granddaughter-mountain-biking-mobile.webp';
// Styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='insurance-financial-planning-1'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent={false}
      // content
      subHeadingText={
        <>
          Insurance policies: making your financial <WidowBlock>plan smarter</WidowBlock>
        </>
      }
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            Insurance isn&#39;t often seen as a key part of a financial plan. Our advisors can show you how the right insurance and{' '}
            <Link
              id='insurance-financial-planning-investment-strategies-link'
              variant='primaryDeemphasize'
              linkUrl='/investments/'>
              investment strategies
            </Link>
            {' '}can give you more options, flexibility, and confidence with a financial plan tailored to your priorities and goals&#8212;now and years from now. Here&#39;s what our version of planning can do:
          </Typography>
          <BulletedListStyled
            bulletedListData={[
              { bulletText: (<>Protect what you&#39;ve worked so hard for.</>) },
              { bulletText: 'Make the most of what you have with recommendations for saving and managing debt.' },
              { bulletText: 'Grow your money with the right investments to reach your goals.' },
            ]}
            bulletType='checkmark'
            disableBottomPadding
            themeType= 'lightTheme'
          />
          <Link
            id='insurance-financial-planning-1-section-cta'
            variant='buttonLinkPrimary'
            linkUrl='/financial-planning/'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='A father and young daughter riding mountain bikes on a trail together'
      imageSrcDefault={financialPlanningImageDesktopWebp.toString()}
      imageSrcMobile={financialPlanningImageMobileWebp.toString()}
    />
  );
};
